<main class="main">
  <app-approvers
    [type]="requestType"
    [loanType]="loanType"
    [moreThan14days]="moreThan14days"
    (selectionAuthorizers)="onSelectionAuthorizers($event)"
    (showApprovers)="onShowApprovers($event)"
  ></app-approvers>
  <div class="main--btnContainer">
    <button
      class="main--btnContainer__btn btn confirm"
      mat-button
      [disabled]="isButtonDisabled()"
      [style]="getButtonStyle()"
      (click)="sendApprovers()"
    >
      {{ 'btnContinue' | i18next | uppercase }}
    </button>
    <button
      class="main--btnContainer__btn btn cancel"
      [style]="'background-color: #2c2a29'"
      mat-button
      (click)="backStep()"
    >
      {{ 'btnReturn' | i18next | uppercase }}
    </button>
  </div>
</main>
